// @ts-nocheck
import { useState } from 'react'
import "./studioOffers.css"

const TABS = ['Studio Classes', 'Online Classes']

const PLANS = {
  'Online Classes': [
    {
      title: '1 Month',
      originalPrice: '399',
      originalStrikethrough: true,
      discountedPrice: 'AED 199',
    },
    {
      title: '3 Months',
      originalPrice: '999',
      originalStrikethrough: true,
      discountedPrice: 'AED 499',
    },
    {
      title: '6 Months',
      originalPrice: '1599',
      originalStrikethrough: false,
      discountedPrice: 'AED 799',
    },
    {
      title: '12 Months',
      originalPrice: '2499',
      originalStrikethrough: false,
      discountedPrice: 'AED 1299',
    },
  ],
  'Studio Classes': [
    {
      title: '1 Month',
      originalPrice: '799',
      originalStrikethrough: true,
      discountedPrice: 'AED 499',
    },
    {
      title: '3 Months',
      originalPrice: '1599',
      originalStrikethrough: true,
      discountedPrice: 'AED 1199',
    },
    {
      title: '6 Months',
      originalPrice: '2099',
      originalStrikethrough: true,
      discountedPrice: 'AED 1499',
    },
    {
      title: '12 Months',
      originalPrice: '3899',
      originalStrikethrough: true,
      discountedPrice: 'AED 2399',
    },
  ],
  'App Classes': [
    {
      title: '1 Month',
      originalPrice: '399',
      originalStrikethrough: true,
      discountedPrice: 'AED 199',
    },
    {
      title: '2 Months\n+\n1 Month Free',
      originalPrice: '699',
      originalStrikethrough: true,
      discountedPrice: 'AED 499',
    },
    {
      title: '3 months\n+\n3 months free',
      originalPrice: '999',
      originalStrikethrough: false,
      discountedPrice: 'AED 799',
    },
  ],
}

function PricingCard({ title, originalPrice, originalStrikethrough, discountedPrice }) {
  const titleLines = title.split('\n')

  return (
    <div className="pricing-card">
      <div className="pricing-card__title">
        {titleLines.map((line, i) => (
          <span key={i}>
            {line}
            {i < titleLines.length - 1 && <br />}
          </span>
        ))}
      </div>
      <div className="pricing-card__price-block">
        <p className="pricing-card__original-price">
          (AED{' '}
          {originalStrikethrough ? (
            <span className="pricing-card__strikethrough">{originalPrice}</span>
          ) : (
            originalPrice
          )}
          )
        </p>
        <p className="pricing-card__discounted-price">{discountedPrice}</p>
      </div>
      <a
        href="https://wa.me/971586340992"
        target="_blank"
        rel="noopener noreferrer"
        className="pricing-card__cta"
      >
        Register Now
      </a>
    </div>
  )
}

export default function StudioOffers() {
  const [activeTab, setActiveTab] = useState('Studio Classes')

  return (
    <section className="pricing">
      <div className="pricing__header">
        <h2 className="pricing__heading">Pricing (Regular Classes)</h2>
        <p className="pricing__validity">
          Register now! Valid till{' '}
          <span className="pricing__validity-date">10th July 2026</span>
        </p>
      </div>

      <div className="pricing__content">
        <div className="pricing__tabs">
          {TABS.map((tab) => (
            <button
              key={tab}
              className={`pricing__tab${activeTab === tab ? ' pricing__tab--active' : ''}`}
              onClick={() => setActiveTab(tab)}
              disabled={tab === 'App Classes'}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="pricing__cards">
          {PLANS[activeTab].map((plan) => (
            <PricingCard key={plan.title} {...plan} />
          ))}
        </div>

        <p className="pricing__disclaimer">
          Disclaimer: <span className="pricing__disclaimer-asterisk">*</span>Prices are inclusive of 5% VAT
        </p>
      </div>
    </section>
  )
}
